const notification = () => {
  return {
    show: false,
    text: null,
    timeout: 4000,
    color: "info", // ['info', 'error', 'success', 'warning']
  };
};

export default {
  state: {
    loading: false,
    error: null,
    language: "pt_BR",
    notification,
  },
  getters: {
    loading(state: any) {
      return state.loading;
    },
    error(state: any) {
      return state.error;
    },
    notification(state: any) {
      return state.notification;
    },
    language(state: any) {
      return state.language;
    },
  },
  // synchronuos
  mutations: {
    setLoading(state: any, payload: any) {
      state.loading = payload;
    },
    setError(state: any, payload: any) {
      state.error = payload;
    },
    setNotification(
      state: any,
      { text = null, timeout = 4000, type = "info" }
    ) {
      state.notification = {
        show: true,
        text,
        timeout,
        color: type, // ['succes', 'info', 'error']
      };
    },
    clearError(state: any) {
      state.error = null;
    },
    clearNotification(state: any) {
      state.notification = notification;
    },
    setLanguage(state: any, payload: any) {
      state.language = payload;
    },
    setSnackbar(state: any, payload: any) {
      state.snackbar = payload;
    },
    closeSnackbar(state: any) {
      state.snackbar.show = false;
    },
  },
  // asynchronous
  actions: {
    clearError({ commit }: { commit: any }) {
      commit("clearError");
    },
    clearNotification({ commit }: { commit: any }) {
      commit("clearNotification");
    },
    setNotification({ commit }: { commit: any }, payload: any) {
      commit("setNotification", payload);
    },
    setLanguage({ commit }: { commit: any }, payload: any) {
      commit("setLanguage", payload);
    },
  },
};
